// extracted by mini-css-extract-plugin
export default {"loader":"MGLoader_loader__vS8D4","spinner":"MGLoader_spinner__nhG8S","mg-loader-spin":"MGLoader_mg-loader-spin__0ohO8"};